<flow-header [title]="!channelId ? 'createChannel.title' : 'editChannel.title' | translate">
  <div class="flex flex-1 items-start justify-end gap-4">
    <flow-button theme="secondary" variation="outline" [routerLink]="['/channels']">
      {{ 'global.cancel' | translate }}
    </flow-button>

    <flow-button theme="primary" variation="fill" (onClick)="onSaveClick()" [disabled]="form.invalid">
      {{ (channelId ? 'global.save' : 'global.add') | translate }}
    </flow-button>
  </div>
</flow-header>

<div class="grid grid-cols-4 gap-10 mt-6">
  <div class="flex flex-col gap-4">
    <div class="self-stretch py-2 rounded justify-start items-center gap-2 inline-flex">
      <div class="justify-start items-center gap-2 flex">
        <app-icon
          iconName="annotation-info"
          size="md"
          class="w-8 h-8 bg-chathams-blue-400 rounded-full flex justify-center items-center"
          stroke="#598fae"></app-icon>
      </div>
      <div class="text-gray-900 text-sm font-semibold leading-[14px]">{{'book.generalInformation' | translate}}</div>
    </div>
    <form [formGroup]="form" class="flex flex-col gap-4">
      <flow-form-input label="createChannel.form.name" formControlName="name" [required]="true"></flow-form-input>
      <flow-form-input label="createChannel.form.address" formControlName="address" [required]="true"></flow-form-input>

      <div class="grid grid-cols-1 md:grid-cols-2 gap-4 min-w-0">
        <flow-form-input
          class="min-w-0 w-full"
          label="createChannel.form.latitude"
          formControlName="latitude"
          [type]="'number'"
          [required]="true"></flow-form-input>

        <flow-form-input
          class="min-w-0 w-full"
          label="createChannel.form.longitude"
          formControlName="longitude"
          [type]="'number'"
          [required]="true"></flow-form-input>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-2 gap-4 min-w-0">
        <flow-form-input
          class="min-w-0 w-full"
          label="createChannel.form.postalCode"
          formControlName="postalCode"
          [required]="true"></flow-form-input>

        <flow-form-input class="min-w-0 w-full" label="createChannel.form.city" formControlName="city" [required]="true"></flow-form-input>
      </div>

      <flow-form-select
        formControlName="customerId"
        [label]="'createChannel.form.customer'"
        [options]="customers"
        [multiple]="false"
        [required]="true"></flow-form-select>

      <flow-form-select
        *ngIf="isAdmin"
        formControlName="lineOfBusiness"
        [label]="'createChannel.form.lineOfBusiness'"
        [options]="lineOfBusinessOptions"
        [multiple]="false"
        [required]="true"></flow-form-select>

      <div class="flex flex-col min-w-0" *ngIf="isAdmin">
        <mat-checkbox class="w-full min-w-0" formControlName="allowTraining" color="primary">
          <span class="flex whitespace-normal break-words">
            {{ 'createChannel.form.allowTraining' | translate }}
          </span>
        </mat-checkbox>
      </div>

      <div class="flex flex-col min-w-0" *ngIf="isAdmin">
        <mat-checkbox class="w-full min-w-0" formControlName="isWeatherCollectionEnabled" color="primary">
          <span class="flex whitespace-normal break-words">
            {{ 'createChannel.form.enableWeather' | translate }}
          </span>
        </mat-checkbox>
      </div>

      <mat-checkbox formControlName="isForecastEnabled" color="primary" *ngIf="isAdmin">
        {{ 'createChannel.form.enableForecastsForThisChannel' | translate }}
      </mat-checkbox>

      <mat-checkbox formControlName="hasClosedDays" color="primary">
        {{ 'createChannel.form.hasClosedDays' | translate }}
      </mat-checkbox>
    </form>
  </div>

  <div class="text-xs">
    <p class="border-l-4 border-chathams-blue-600 pl-1">{{ 'createScreen.note' | translate }}</p>
    <p>{{ 'channels.note' | translate }}</p>
  </div>
</div>
